export default __webpack_public_path__ + "static/kb_3_16-9c29b5d000ac97f300b9e532d6949de1.jpg";